import React, { FC } from "react";

import { useTranslation } from "react-i18next";
import { CircularProgress } from "@mui/material";

import { ArrowLeftBig } from "@/assets/icons";

import ConversationChatInput, {
    ChatInputFormType,
    InputMode,
} from "./components/ConversationChatInput/ConversationChatInput";
import ConversationMessage from "./components/ConversationMessage/ConversationMessage";
import {
    ConversationInfoBottomMessage,
    ConversationMessageChatContainer,
    ConversationProgressContainer,
} from "./styled";

type ConversationMessageChatProps = {
    loading: boolean;
    conversation: MyBrokerApi.Conversation;
    onSubmitForm: (formData: ChatInputFormType) => Promise<boolean>;
    onBackPressed?: () => void;
};

const ConversationMessageChat: FC<ConversationMessageChatProps> = ({
    loading,
    conversation,
    onSubmitForm,
    onBackPressed,
}) => {
    const { t } = useTranslation();

    return (
        <ConversationMessageChatContainer>
            <div className="chat-header">
                {onBackPressed && (
                    <div className="chat-header-action-icons">
                        <ArrowLeftBig onClick={onBackPressed} />
                    </div>
                )}
                <div className="chat-header-title-container">
                    <div className="chat-title">
                        {conversation?.file.id} {conversation?.file.name}
                        {conversation?.isArchived && <span className="archive">{t("Common.Archive")}</span>}
                        {conversation?.isReadonly && <span className="readonly">{t("Common.Info")}</span>}
                    </div>
                    <div className="chat-subject-label">{conversation?.topic}</div>
                </div>
            </div>

            {loading ? (
                <ConversationProgressContainer>
                    <CircularProgress />
                </ConversationProgressContainer>
            ) : (
                <div className="conversation-chat-container">
                    {conversation?.messages?.sortBy("-timestamp").map((message) => (
                        <ConversationMessage
                            key={`message-${message.id}`}
                            message={message}
                            conversationId={conversation.id}
                            isArchived={conversation.isArchived}
                        />
                    ))}
                </div>
            )}
            {conversation?.isArchived && (
                <ConversationInfoBottomMessage>
                    <hr />
                    <span>{t("Conversation.ThisConversationIsArchived")}</span>
                    <hr />
                </ConversationInfoBottomMessage>
            )}
            {conversation?.isReadonly && (
                <ConversationInfoBottomMessage>
                    <hr />
                </ConversationInfoBottomMessage>
            )}
            {!conversation?.isArchived && !conversation?.isReadonly && (
                <ConversationChatInput
                    inputMode={InputMode.ExistingConversation}
                    onSubmitForm={onSubmitForm}
                    disabled={loading}
                />
            )}
        </ConversationMessageChatContainer>
    );
};

export default ConversationMessageChat;
